import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import "./basic-information.scss";
import axios from "axios";
import { useLocation, useNavigate } from 'react-router-dom';
import convert from "../../Helper/helper";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import HandshakeIcon from '@mui/icons-material/Handshake';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PatinetInfo from "../PatientInfo/patientInfo";
import { submitAndRecieveFee } from "./opd/opdService";
import { errorToast, successToast } from "../toastmessage/toastmessage";
import { opdValidation } from "./opd/opdValidation";
import ModalPopUp from "../ModalPopup/ModalPopUp";
import { OPDPrint } from "../../pages/OPD/OPD.Service";
import { printFunc } from "../../utils/utils";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

let initialState = {
    patientName: "",
    regDate: convert(new Date()),
    consultationType: null,
    departmentId: "",
    doctorId: "",
    expectedDateOfDelivery: convert(new Date()),
    referralId: "",

}
const OPDInformation = (props) => {
    let location = useLocation();
    const { submitOpdInfo } = props
    const navigate = useNavigate();
    const [departmentList, setDepartmentList] = useState([]);
    const [referralList, setReferralList] = useState([]);
    const [doctorList, setDoctorList] = useState([]);
    const [opdInfoInputFields, setOpdnfoInputFields] = React.useState(initialState);
    const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))
    const [errors, setError] = useState({})
    const [open, setOpen] = React.useState(false);
    const [OPDID, setOPDetails]  = useState("")

    const handleOpdfoInputChange = (event) => {
        const { name, value } = event.target;
        setOpdnfoInputFields((prevState) => {
            return {
                ...prevState,
                [name]: value,
            };
        });
    }
    const getDepartmentList = () => {
        axios.get("https://arogyanxtdevapi.fundaclear.in/api/Department")
            .then((res) => {
                if (res?.status === 200) setDepartmentList(res?.data?.result)
            }).catch((err => console.log(err)))
    }
    const getReferralList = () => {
        axios.get("https://arogyanxtdevapi.fundaclear.in/api/Referral")
            .then((res) => {
                if (res?.status === 200) setReferralList(res?.data?.result)
            }).catch((err => console.log(err)))
    }

    const getDoctorList = () => {
        axios.get("https://arogyanxtdevapi.fundaclear.in/api/Doctor")
            .then((res) => {
                if (res?.status === 200) setDoctorList(res?.data?.result)
            }).catch((err => console.log(err)))
    }

    useEffect(() => {
        getDepartmentList();
        getReferralList();
        getDoctorList("")
    }, []);

    const handleRouteReiceveFeeAndPrint = async () => {
        try {
            let res = await OPDPrint(OPDID)
            if (res?.status === 200) {
                setOpen(false)
                await printFunc(res?.data, "opd")
                setOpdnfoInputFields(initialState)
                navigate("/patient-recieve-fee", { state: { patientID: location?.state?.rowData?.uniqueID, referralId: opdInfoInputFields?.referralId, rowData: location?.state?.rowData } })
            }
        } catch (err) {
            errorToast(err?.response?.data?.error || err?.response?.data?.message)
        }

    }
    const submit = async (event, parentID, opdInfoInputFields, type) => {
        let params = {
            consultationType: Number(opdInfoInputFields?.consultationType),
            departmentId: opdInfoInputFields?.departmentId,
            doctorId: opdInfoInputFields?.doctorId,
            expectedDateOfDelivery: opdInfoInputFields?.expectedDateOfDelivery,
            referralId: opdInfoInputFields?.referralId,
            regDate: opdInfoInputFields?.regDate,
            createdBy: getUserValue?.uniqueID,
            patientID: parentID
        }
        let isValid = await opdValidation(params)
        if (type === "create") {
            if (isValid?.isValid) {
                await submitOpdInfo(event, parentID, params)
                setOpdnfoInputFields(initialState)
            } else {
                setError(isValid)
            }
        } else {
            try {
                if (isValid?.isValid) {
                    let reciveFee = await submitAndRecieveFee(parentID, params);
                    setOPDetails(reciveFee?.data?.result)
                    if (reciveFee?.status === 200) {
                        successToast(reciveFee?.data?.message);
                        setOpen(true)
                    }
                } else {

                    setError(isValid)
                }
            } catch (err) {
                errorToast(err?.response?.data?.error || err?.response?.data?.message)
            }
        }
    }

    const handleBlur = async () => {
        const newErrors = await opdValidation(opdInfoInputFields);
        setError(newErrors)

    };

    const handleGoBack = () => {
        navigate("/opd-list")
    }
    return (
        <>
            <div className="patient-info">
                {location?.state === null ? null : <PatinetInfo rowData={location} />}
            </div>
            <form>
                <div className="basic-info" >
                    <div className="mt-2 ml-4">
                        <h4>Add OPD</h4>
                        <div className="back-btn"
                            onClick={handleGoBack}
                        >
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Reg Date</label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><CalendarMonthIcon /></div>
                                </div>
                                <input
                                    type="date" className="form-control" id="lname" placeholder="Reg Date" name='regDate' value={opdInfoInputFields?.regDate} onChange={handleOpdfoInputChange}
                                />
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Department*</label>
                            <div className="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><DomainAddIcon /></div>
                                </div>
                                <select
                                    onBlur={handleBlur}
                                    className={
                                        errors?.errors?.departmentId?.length > 0 ? "form-control is-invalid" :
                                            "form-control"
                                    }
                                    aria-label=".form-select-sm example" name="departmentId" value={opdInfoInputFields?.departmentId} onChange={handleOpdfoInputChange}>
                                    <option selected>Open this select menu</option>
                                    {
                                        departmentList && departmentList?.length > 0 && departmentList.map((depName) => {
                                            return (<><option value={depName?.uniqueId}>{depName?.departmentName
                                            }</option></>)
                                        })
                                    }
                                </select>

                                <div class="invalid-feedback">
                                    {errors?.errors?.departmentId}
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Doctor*</label>
                            <div className="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><LocalHospitalIcon /></div>
                                </div>
                                <select
                                    onBlur={handleBlur}
                                    className={
                                        errors?.errors?.doctorId?.length > 0 ? "form-control is-invalid" :
                                            "form-control"
                                    }
                                    aria-label=".form-select-sm example" name="doctorId" value={opdInfoInputFields?.doctorId} onChange={handleOpdfoInputChange}>
                                    <option selected>Open this select menu</option>
                                    {
                                        doctorList && doctorList?.length > 0 && doctorList.map((docName) => {
                                            return (<><option value={docName?.uniqueId}>{docName?.doctorName
                                            }</option></>)
                                        })
                                    }
                                </select>
                                <div class="invalid-feedback">
                                    {errors?.errors?.doctorId}
                                </div>

                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Consultation / Follow-up</label>
                            <div className="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><HandshakeIcon /></div>
                                </div>
                                <select className="form-control" aria-label="Default select example"
                                    id="consultationType"
                                    placeholder="Consultation Type"
                                    name="consultationType"
                                    value={opdInfoInputFields?.consultationType} min="0"
                                    onChange={handleOpdfoInputChange}
                                >
                                    <option selected>Open this select menu</option>
                                    <option value="0">Consultation</option>
                                    <option value="1">Followup</option>

                                </select>

                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Referral</label>
                            <div className="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><GroupAddIcon /></div>
                                </div>
                                <select
                                    onBlur={handleBlur}
                                    className={
                                        errors?.errors?.referralId?.length > 0 ? "form-control is-invalid" :
                                            "form-control"
                                    }
                                    aria-label=".form-select-sm example" name="referralId" value={opdInfoInputFields?.referralId} onChange={handleOpdfoInputChange}>
                                    <option selected>Open this select menu</option>
                                    {
                                        referralList && referralList?.length > 0 && referralList.map((refName) => {
                                            return (<><option value={refName?.uniqueId}>{refName?.referralName
                                            }</option></>)
                                        })
                                    }
                                </select>
                                <div class="invalid-feedback">
                                    {errors?.errors?.referralId}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2" onClick={(event) => { submit(event, location?.state?.rowData?.uniqueID, opdInfoInputFields, "create") }}
                    >Create OPD</Button>
                    <Button variant="outlined"
                        onClick={(event) => { submit(event, location?.state?.rowData?.uniqueID, opdInfoInputFields, "submitAndRecieveFee") }}
                        disabled={false}
                    >Submit & Receive Fee</Button>
                </div>
            </form>
            {
                open && <ModalPopUp open={open} setOpen={setOpen} headerText={"Print The OPD"} handleRouteReiceveFee={handleRouteReiceveFeeAndPrint} />
            }
        </>
    );
};

export default OPDInformation; 